import { Vue, prop } from 'vue-class-component';
import { WidgetWrapper } from '@/components/widget-wrapper';
import { TileSelector } from '@/components/tile-selector';
import { CompareDataObject } from '@/types/writeup';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import styles from './styles.module.scss';

class MilesSelectorProps {
	compareData = prop<CompareDataObject[]>({ default: undefined })

	active = prop<string>({ default: undefined })

	loading = prop<boolean>({ default: true })

	onChange = prop<Function>({ default: () => () => undefined })
}

export class MilesSelector extends Vue.with(MilesSelectorProps) {
	@Inject() readonly i18n!: VueI18n;

	get tiles() {
		return this?.compareData?.[0]?.programMiles ? this.compareData[0].programMiles.map(option => ({
			id: String(option),
			title: this.i18n.t('milesSelector.milesValue', { value: this.i18n.n(option), count: option }),
		})) : [];
	}

	render() {
		return (
			<WidgetWrapper
				class={ styles.milesSelector }
				title={ this.i18n.t('milesSelector.title')}
				active={ true }
				loading={ this.loading }
			>
				<TileSelector
					tiles={ this.tiles }
					active={ String(this.active) }
					onChange={ this.onChange }
					skeletonOptions={ { description: false, count: 3 } }
				/>
			</WidgetWrapper>
		);
	}
}
